import { listItemWrapper } from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { Member } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const { getItem: getMember } = listItemWrapper<Member>(apiClient, {
      path: `/api/v${version}/members`
    })

    return { getMember }
  }
} satisfies Starter
